onReady(($) => {
    $('.social-sharing-click')
        .on('click', function () {
            var URL = $(this)
                .attr("href");
            var title = $(this)
                .attr("title") + "-share";

            if (title === 'twitter-share') {
                window.open(URL, title, 'width=550,height=235');
            }

            if (title === 'facebook-share') {
                window.open(URL, title, 'width=580,height=296');
            }

            if (title === 'pinterest-share') {
                window.open(URL, title, 'width=490,height=530');
            }

            if (title === 'reddit-share') {
                window.open(URL, title, 'width=490,height=530');
            }

            if (title === 'linkedin-share') {
                window.open(URL, title, 'width=490,height=530');
            }
            return false;
        });
});
